import { all } from 'redux-saga/effects';

import watchPushDataGetRequest from './watchPushDataGetRequest';
import watchPushCreateRequest from './watchPushCreateRequest';

function* pushSaga() {
    yield all([
        watchPushDataGetRequest(),
        watchPushCreateRequest()
    ])
}

export default pushSaga;